import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Lock, AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { hasRole } from "@/lib/roles";

// Grace banner + full lock screen. Locked companies can only reach the Billing pages.
export const BillingGate = ({ children }) => {
    const { user, logout } = useAuth();
    const { pathname } = useLocation();
    const [s, setS] = useState(null);
    const isAdmin = hasRole(user, "admin");

    useEffect(() => {
        api.get("/billing/status").then(({ data }) => setS(data)).catch(() => {});
    }, [pathname]);

    const onBilling = pathname.startsWith("/billing");
    if (s?.status === "locked" && !onBilling) {
        return (
            <div className="min-h-[80vh] flex items-center justify-center p-6" data-testid="billing-locked-screen">
                <div className="max-w-md bg-white border border-ink/10 p-8 text-center">
                    <div className="mx-auto w-14 h-14 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center"><Lock className="w-7 h-7" /></div>
                    <h1 className="mt-5 font-display font-extrabold text-3xl text-ink">Subscription expired</h1>
                    <p className="mt-2 text-sm text-ink/60">
                        {isAdmin ? "Renew your annual plan to unlock the app for everyone in your company." : "Your company's subscription needs renewing. Please ask your Admin to renew it."}
                    </p>
                    {isAdmin ? (
                        <Link to="/billing" className="mt-6 inline-flex bg-klein text-white px-6 py-3 text-sm" data-testid="billing-locked-renew">Renew plan</Link>
                    ) : (
                        <button onClick={logout} className="mt-6 inline-flex border border-ink/20 px-6 py-3 text-sm" data-testid="billing-locked-logout">Sign out</button>
                    )}
                </div>
            </div>
        );
    }
    return (
        <>
            {s?.status === "grace" && isAdmin && !onBilling && (
                <Link to="/billing" data-testid="billing-grace-banner"
                    className="flex items-center gap-2 px-5 py-2.5 bg-amber-100 text-amber-900 text-sm hover:bg-amber-200 dark:bg-amber-500/15 dark:text-amber-200">
                    <AlertTriangle className="w-4 h-4 shrink-0" />
                    <span><b>{s.days_left} day{s.days_left === 1 ? "" : "s"}</b> left to pay your annual plan before the app locks. Pay now →</span>
                </Link>
            )}
            {children}
        </>
    );
};

export default BillingGate;
